export const heroSectionData = [
  {
    id: 1,
    img: 'https://i.ibb.co/xC7WXbc/favpng-slip-dress-clothing-casual-fashion.png',
    alt: 'girl-in-glasses-and-beautiful-summer-dress',
    title: 'SUMMER SELLOUT',
    description:
      'DON`T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.',
    bg: 'fcf1ed',
  },
  {
    id: 2,
    img: 'https://i.ibb.co/BZpC0MW/Png-Item-5162636.png',
    alt: 'girl-in-black-autumn-jacket-and-black-pants',
    title: 'AUTUMN COLECTION',
    description:
      'DON`T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.',
    bg: 'f5fafd',
  },
  {
    id: 3,
    img: 'https://i.ibb.co/7vFj3v7/pngkey-com-gigi-hadid-png-1324578.png',
    alt: 'casual-style-dressed-girl',
    title: 'POPULAR NOW',
    description:
      'DON`T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.',
    bg: 'fbf0f4',
  },
];

export const categories = [
  {
    id: 1,
    img: 'https://i.ibb.co/z2s2Shy/hmgoepprod.jpg',
    alt: 'girl-in-white-shirt',
    title: 'SHIRT STYLE!',
    category: 't-shirts',
  },
  {
    id: 2,
    img: 'https://i.ibb.co/1RMJhhg/hmgoepprod-1.jpg',
    alt: 'girl-in-grey-loungewear',
    title: 'LOUNGEWEAR LOVE',
    category: 'loungewear',
  },
  {
    id: 3,
    img: 'https://i.ibb.co/Ln9rYMv/hmgoepprod-2.jpg',
    alt: 'girl-in-red-jacket-costume',
    title: 'LIGHT JACKETS',
    category: 'jackets',
  },
  // {
  //     id: 4,
  //     img: "https://lp2.hm.com/hmgoepprod?set=quality%5B79%5D%2Csource%5B%2F6b%2Fbe%2F6bbe8232a27b2a3d04f53d08938b0e68b830211c.jpg%5D%2Corigin%5Bdam%5D%2Ccategory%5B%5D%2Ctype%5BLOOKBOOK%5D%2Cres%5Bm%5D%2Chmver%5B1%5D&call=url[file:/product/main]",
  //     title: "NEW DRESSES"
  // },
  // {
  //     id: 5,
  //     img: "https://lp2.hm.com/hmgoepprod?set=quality%5B79%5D%2Csource%5B%2Fa0%2F89%2Fa0893f4ec190fac29b688bc4f73937cfedc6b758.jpg%5D%2Corigin%5Bdam%5D%2Ccategory%5B%5D%2Ctype%5BLOOKBOOK%5D%2Cres%5Bm%5D%2Chmver%5B1%5D&call=url[file:/product/main]",
  //     title: "THE PERFECT JEANS"
  // }
];

export const popularProducts = [
  {
    id: 1,
    img: 'https://i.ibb.co/DWXHT1m/hmgoepprod-1-removebg-preview.png',
    alt: '',
  },
  {
    id: 2,
    img: 'https://i.ibb.co/Kh40d7s/hmgoepprod-2-removebg-preview.png',
    alt: '',
  },
  {
    id: 3,
    img: 'https://i.ibb.co/LNvjGL9/hmgoepprod-3-removebg-preview.png',
    alt: '',
  },
  {
    id: 4,
    img: 'https://i.ibb.co/dcgFtSM/hmgoepprod-6-removebg-preview.png',
    alt: '',
  },
  {
    id: 5,
    img: 'https://i.ibb.co/NtYq6fk/hmgoepprod-7-removebg-preview.png',
    alt: '',
  },
  {
    id: 6,
    img: 'https://i.ibb.co/m4LGGnC/hmgoepprod-1-removebg-preview.png',
    alt: '',
  },
  {
    id: 7,
    img: 'https://i.ibb.co/cC1MM0D/hmgoepprod-4-removebg-preview.png',
    alt: '',
  },
  {
    id: 8,
    img: 'https://i.ibb.co/RQrNT8V/hmgoepprod-removebg-preview.png',
    alt: '',
  },
];
